module.exports = __webpack_public_path__ + "img/Bci.43a3bb9d.png";